import { render, staticRenderFns } from "./CustomerSales.vue?vue&type=template&id=0375c39d"
import script from "./CustomerSales.vue?vue&type=script&lang=js"
export * from "./CustomerSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports